export enum MissionTab {
  DAILY = 'daily',
  GAME_WEEKLY = 'weekly',
  SEASONAL = 'seasonal',
}
